// extracted by mini-css-extract-plugin
module.exports = {"simulation-popup":"SimulationPopup_simulation-popup__pBQEq","close":"SimulationPopup_close__dTh_1","content":"SimulationPopup_content__LP6UL"};